import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./ButtonWithIcon.module.scss";

const ButtonWithIcon = ({
  className,
  labelText,
  img_url_inactive,
  img_url_active,
  img_url_disable,
  img_width,
  img_height,
  clickHandler,
  buttonLabelStyle,
  id,
  disableBackButton,
}) => {
  const [src, setSrc] = useState(img_url_active);
  useEffect(() => {
    setSrc(disableBackButton ? img_url_disable : img_url_inactive);
  }, [disableBackButton]);

  return (
    <button
      className={`${className} ${styles["button-container"]}`}
      onClick={clickHandler}
      onMouseOver={
        !disableBackButton ? () => setSrc(img_url_active) : undefined
      }
      onMouseOut={
        !disableBackButton ? () => setSrc(img_url_inactive) : undefined
      }
      id={id}
      disabled={disableBackButton}
    >
      <div>
        {src && (
          <img
            className={disableBackButton ? `${styles["disable-img"]}` : "image"}
            src={src}
            alt=""
            width={img_width}
            height={img_height}
          />
        )}
      </div>

      <label
        className={
          disableBackButton
            ? `${styles["disable-button-label"]} ${buttonLabelStyle}`
            : `${styles["button-label"]} ${buttonLabelStyle}`
        }
        id={`button-label-${labelText}`}
      >
        {labelText}
      </label>
    </button>
  );
};

ButtonWithIcon.propTypes = {
  className: PropTypes.string,
  labelText: PropTypes.string,
  img_url_inactive: PropTypes.string,
  img_url_active: PropTypes.string,
  img_width: PropTypes.number,
  img_height: PropTypes.number,
  clickHandler: PropTypes.func,
  id: PropTypes.string,
};

export default ButtonWithIcon;
